// src/components/common/Navbar.js

import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import brasao from '../../assets/brasao.png';

const NAV_LINKS = [
  { to: '/',             label: 'Home' },
  { to: '/batismo',      label: 'Batismo' },
  { to: '/noivos',       label: 'Curso de Noivos' },
  { to: '/capelas',      label: 'Comunidades' },
  { to: '/sacramentos',  label: 'Sacramentos' },
  { to: '/dizimo',       label: 'Dízimo' },
  { to: '/solicitacoes', label: 'Solicitações' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 1000,
      transition: 'all 0.3s ease',
      background: scrolled ? 'var(--navy)' : 'rgba(26,58,107,0.9)',
      backdropFilter: 'blur(10px)',
      boxShadow: scrolled ? 'var(--shadow-lg)' : 'none',
    }}>
      <div className="container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--space-xl)',
        height: '72px',
      }}>
        {/* Logo com brasão */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
          <img
            src={brasao}
            alt="Brasão Paróquia Nossa Senhora da Conceição"
            style={{ width: 40, height: 40, objectFit: 'contain', filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.4))' }}
          />
          <div>
            <div style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              color: 'var(--white)',
              fontSize: '0.95rem',
              lineHeight: 1.15,
            }}>
              N. Sra. da Conceição
            </div>
            <div className="navbar-subtitle" style={{ color: 'var(--gold)', fontSize: '0.68rem', letterSpacing: '0.07em' }}>
              Messejana · Fortaleza – CE
            </div>
          </div>
        </Link>

        {/* Nav Desktop */}
        <nav className="hide-mobile" style={{ display: 'flex', gap: '0.15rem' }}>
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              style={({ isActive }) => ({
                padding: '0.5rem 0.85rem',
                borderRadius: 'var(--radius-sm)',
                fontWeight: 500,
                fontSize: '0.82rem',
                letterSpacing: '0.02em',
                color: isActive ? 'var(--gold)' : 'rgba(255,255,255,0.85)',
                textDecoration: 'none',
                transition: 'all 0.2s',
                background: isActive ? 'rgba(201,160,48,0.12)' : 'transparent',
                whiteSpace: 'nowrap',
              })}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Hamburger Mobile */}
        <button
          className="hide-desktop"
          onClick={() => setOpen(o => !o)}
          aria-label="Menu"
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--white)',
            fontSize: '1.5rem',
            cursor: 'pointer',
            padding: '0.5rem',
          }}
        >
          {open ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div style={{
          background: 'var(--navy-dark)',
          padding: 'var(--space-md) var(--space-xl)',
          borderTop: '1px solid rgba(201,160,48,0.2)',
        }}>
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              onClick={() => setOpen(false)}
              style={({ isActive }) => ({
                display: 'block',
                padding: '0.875rem 0',
                fontWeight: 500,
                color: isActive ? 'var(--gold)' : 'rgba(255,255,255,0.85)',
                textDecoration: 'none',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
                fontSize: '0.95rem',
              })}
            >
              {label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;